import { JSX } from "react";

import { Avatar, IconButton, useTheme } from "@mui/material";

import { avatarStyles, getAvatarName, type IProfileButtonParams } from "./helpers/Profile.helper";

const styles = {
  iconButton: { p: 0 },
};

function ProfileButton({ username, familyName, handleClick, isOpen }: IProfileButtonParams): JSX.Element | null {
  const theme = useTheme();
  if (!username) {
    return null;
  }

  return (
    <IconButton
      id='profile-toggle-button'
      aria-controls={isOpen ? "profile-menu" : undefined}
      aria-haspopup='true'
      aria-expanded={isOpen ? "true" : undefined}
      onClick={handleClick}
      sx={styles.iconButton}
      size='small'
    >
      <Avatar sx={avatarStyles(theme)}>
        {getAvatarName(username)}
        {getAvatarName(familyName)}
      </Avatar>
    </IconButton>
  );
}

export default ProfileButton;
